import { Injectable } from '@angular/core';
import { UseCase } from '../../base';
import { AdditionalDataKey } from '../../domain/models';
import { AdditionalDataKeysRepository } from '../../repositories';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class GetAdditionalDataKeysUseCase
  implements UseCase<string, AdditionalDataKey[]>
{
  constructor(
    private additionalDataKeyRepository: AdditionalDataKeysRepository
  ) {}

  execute(params: string | undefined): Observable<AdditionalDataKey[]> {
    return this.additionalDataKeyRepository.getAdditionalDataKeys(params);
  }
}
